import React, { useEffect, useState } from 'react';
import '../styles/QualisuId.css';

interface QualisuIdProps {
  id?: string | null;
  reference?: boolean;
  label?: string;
}

const QualisuId: React.FC<QualisuIdProps> = ({ id, reference = false, label: customLabel }) => {
  const label = customLabel || (reference ? 'Referans Qualisu ID' : 'Qualisu ID');
  const [copyStatus, setCopyStatus] = useState('');

  useEffect(() => { setCopyStatus(''); }, [id]);

  const copyId = async () => {
    if (!id) return;
    try {
      await navigator.clipboard.writeText(id);
      setCopyStatus('Kopyalandı');
    } catch {
      setCopyStatus('Kopyalanamadı. ID’yi seçerek kopyalayabilirsiniz.');
    }
  };

  return (
    <div className="qualisu-id">
      <span className="qualisu-id-label">{label}</span>
      <div className="qualisu-id-value">
        {id ? <>
          <code>{id}</code>
          <button type="button" onClick={copyId} aria-label={label + ' kopyala'}>Kopyala</button>
        </> : <span className="qualisu-id-empty">Kaynak ID bulunmuyor</span>}
      </div>
      <span className="qualisu-id-status" role="status">{copyStatus}</span>
    </div>
  );
};

export default QualisuId;
